<template>
    <div class="card sidebar-menu list-group list-group-flush bg-bright p-3 mt-3" >
        <router-link v-for="item in leftMenu" v-bind:key="item.id+Math.random(1024)" :to="item.link" :class="`menu-item ${active==item.value?'active':''}`" :data-value="item.value">
        <!-- <i class="menu-item-icon material-symbols-outlined">{{item.icon}}</i> -->
            <span class="menu-item-text">{{item.label}}</span>
        </router-link>
    </div>
</template>
<script>
export default {
  name: 'LeftMenu',
  props: {
    active:String
  },
  data:function(){
      return {
        leftMenu:[
            {icon:'',label:'Cara Pembayaran',link:'/master/asuransi',value:'asuransi',id:1},
            {icon:'',label:'Asuransi',link:'/master/asuransi-lain',value:'asuransi_lain',id:2},
            {icon:'',label:'Bank',link:'/master/bank',value:'bank',id:1000},
            {icon:'',label:'Faskes',link:'/master/faskes',value:'faskes',id:99},
            {icon:'',label:'Lokasi',link:'/master/lokasi',value:'lokasi',id:90},
            {icon:'',label:'User',link:'/master/user',value:'user',id:15},
            {icon:'',label:'Kamar Ranap',link:'/master/kamar',value:'kamar',id:14},
            {icon:'',label:'Klasifikasi Medis',link:'/master/penyakit',value:'penyakit',id:15},
            {icon:'',label:'Dokter',link:'/master/dokter',value:'dokter',id:2},
            {icon:'',label:'Jadwal Dokter',link:'/master/jadwal-dokter',value:'jadwal-dokter',id:3},
            {icon:'',label:'Obat / Alkes',link:'/master/obat',value:'obat',id:4},
            {icon:'',label:'Optik',link:'/master/optik-item',value:'optik-item',id:5},
            {icon:'',label:'Periksa Lab',link:'/master/periksa-lab',value:'periksa-lab',id:6},
            {icon:'',label:'Petugas',link:'/master/petugas',value:'petugas',id:7},
            {icon:'',label:'Tindakan',link:'/master/tindakan',value:'tindakan',id:8},
            {icon:'',label:'Unit',link:'/master/unit',value:'unit',id:9},
            {icon:'',label:'Wilayah',link:'/master/provinsi',value:'provinsi',id:10},
            // {icon:'',label:'Kota',link:'/master/kota',value:'kota',id:11},
            // {icon:'',label:'Kecamatan',link:'/master/kecamatan',value:'kecamatan',id:12},
            // {icon:'',label:'Kelurahan',link:'/master/kelurahan',value:'kelurahan',id:13},
            {icon:'',label:'Periode',link:'/master/periode',value:'periode',id:14},
        ]
      }
  }
}
</script>

